module.exports = __webpack_public_path__ + "static/frank-russo-8d4f7710936139dadd317a5764883746.png";